import { inject, Injectable } from '@angular/core';
import { endpoints } from '../../environments/endpoints';
import { ApiRequestOptions, ApiService } from '../Modules/Shared/Services/api.service';
import {
  IndexQueryParams,
  IndexResponse,
  ShowResponse,
  StoreResponse,
  UpdateResponse,
  DeleteResponse,
} from '../Interfaces/api/roles.interface';
import { PermissionsResponse } from '../Interfaces/api/roles.interface';
import { LaravelDefaultResponse } from '../Modules/Shared/Interfaces/response.interface';
import { HttpParams, HttpResourceRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private _apiService = inject(ApiService);

  index(queryParams?: IndexQueryParams, skipLoading: boolean = true): HttpResourceRequest {
    const params = this.buildQueryParams(queryParams);
    return this._apiService.get<IndexResponse>(endpoints.api.roles.index, { params, skipLoading });
  }

  show(roleId: string, skipLoading: boolean = true): HttpResourceRequest {
    return this._apiService.get<ShowResponse>(endpoints.api.roles.show(roleId), { skipLoading });
  }

  create(body: { name: string; permissions: number[] }, skipLoading: boolean = false,): Observable<StoreResponse> {
    const request = this._apiService.post<StoreResponse>(endpoints.api.roles.store, { body, skipLoading, });
    return this._apiService.run<StoreResponse>(request);
  }

  update(roleId: string, data: { name?: string; permissions?: number[] }, skipLoading: boolean = false,): Observable<UpdateResponse> {
    const request = this._apiService.put<UpdateResponse>(endpoints.api.roles.update(roleId), { body: data, skipLoading, });
    return this._apiService.run<UpdateResponse>(request);
  }

  delete(roleId: string, skipLoading: boolean = false): Observable<DeleteResponse> {
    const request = this._apiService.delete<DeleteResponse>(endpoints.api.roles.delete(roleId), { skipLoading, });
    return this._apiService.run<DeleteResponse>(request);
  }

  permissions(skipLoading: boolean = true): HttpResourceRequest {
    return this._apiService.get<LaravelDefaultResponse<PermissionsResponse>>(endpoints.api.roles.permissions, { skipLoading },);
  }

  checkName(name: string, excludeId?: string, skipLoading: boolean = true): Observable<LaravelDefaultResponse<{ is_unique: boolean }>> {
    let params = new HttpParams().set('name', name);
    if (excludeId) {
      params = params.set('exclude_id', excludeId);
    }
    const request = this._apiService.get<LaravelDefaultResponse<{ is_unique: boolean }>>(endpoints.api.roles.checkName, { params, skipLoading });
    return this._apiService.run<LaravelDefaultResponse<{ is_unique: boolean }>>(request);
  }

  private buildQueryParams(queryParams?: IndexQueryParams): HttpParams {
    let params = new HttpParams();
    params = params.set('pageSize', queryParams?.pageSize?.toString() ?? '10');
    params = queryParams?.page != null ? params.set('page', queryParams.page.toString()) : params;
    params = queryParams?.orderBy ? params.set('orderBy', queryParams.orderBy) : params;
    params = queryParams?.search ? params.set('search', queryParams.search) : params;
    params = queryParams?.order ? params.set('order', queryParams.order) : params;
    return params;
  }
}
